"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tokenRefreshLink = void 0;
/**
 * Copy pasted from https://github.com/larskarbo/trpc-token-refresh-link/tree/main
 * to make it compatible with tRPC v11.6.0
 */
const client_1 = require("@trpc/client");
const observable_1 = require("@trpc/server/observable");
const tokenRefreshLink = ({ tokenRefreshNeeded, fetchAccessToken }) => () => {
    let refreshPromise;
    return (options) => {
        const { next, op } = options;
        return (0, observable_1.observable)((observer) => {
            if (!tokenRefreshNeeded(op)) {
                return next(op).subscribe(observer);
            }
            refreshPromise ??= fetchAccessToken(op);
            refreshPromise
                .then(() => {
                next(op).subscribe(observer);
            })
                .catch((error) => {
                observer.error(client_1.TRPCClientError.from(error));
            })
                .finally(() => {
                refreshPromise = undefined;
            });
        });
    };
};
exports.tokenRefreshLink = tokenRefreshLink;
//# sourceMappingURL=trpc-refresh-token-link.js.map